import {
  blue,
  cyan,
  geekblue,
  gold,
  green,
  grey,
  lime,
  magenta,
  purple,
  red,
  volcano,
  yellow,
} from '@ant-design/colors'

import {
  ColorConfigType,
  PaletteColorConfig,
  PaletteOrigin,
  PaletteType,
  RandomColorConfig,
  ShadingColorConfig,
  ShadingPresetName,
  ShadingType,
} from 'Colors/types'
import { MAPOSAIC_PALETTES } from './palettes/maposaicPalettes'

export const AntColors = {
  [ShadingPresetName.Blue]: blue,
  [ShadingPresetName.Red]: red,
  [ShadingPresetName.Volcano]: volcano,
  [ShadingPresetName.Gold]: gold,
  [ShadingPresetName.Yellow]: yellow,
  [ShadingPresetName.Lime]: lime,
  [ShadingPresetName.Green]: green,
  [ShadingPresetName.Cyan]: cyan,
  [ShadingPresetName.Geekblue]: geekblue,
  [ShadingPresetName.Purple]: purple,
  [ShadingPresetName.Magenta]: magenta,
  [ShadingPresetName.Grey]: grey,
}

export const ROAD_BLACK = '#222222'

export const ColorConfigNamesAndImage = {
  [ColorConfigType.Random]: {
    name: 'Random',
    imgPath: '/assets/color_samples/map_random.png',
  },
  [ColorConfigType.Shading]: {
    name: 'Shading',
    imgPath: '/assets/color_samples/map_shading.png',
  },
  [ColorConfigType.Palette]: {
    name: 'Palette',
    imgPath: '/assets/color_samples/map_palette.png',
  },
}

export const RANDOM_CONFIG: RandomColorConfig = {
  type: ColorConfigType.Random,
}

export const DEFAULT_SHADING_CONFIG: ShadingColorConfig = {
  type: ColorConfigType.Shading,
  shadingType: ShadingType.Preset,
  seedColor: ShadingPresetName.Blue,
}
export const PALETTE_KEYS = Object.keys(MAPOSAIC_PALETTES) as (keyof typeof MAPOSAIC_PALETTES)[]
export const INITIAL_PALETTE_KEY = PALETTE_KEYS[
  Math.floor(Math.random() * PALETTE_KEYS.length)
] as keyof typeof MAPOSAIC_PALETTES

export const DEFAULT_PALETTE_CONFIG: PaletteColorConfig = {
  type: ColorConfigType.Palette,
  paletteType: PaletteType.Preset,
  origin: PaletteOrigin.Maposaic,
  paletteKey: INITIAL_PALETTE_KEY,
}
